import AnalyticsHelper from '../../utils/analytics-helper.js';
import DealerMapper from '../../utils/dealer-mapper.js';

export default class DealerResults {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.batd-results');
        this.loader = parent.loader;
        this.resultsTemplate = _.template(parent.el.querySelector('#dealer-results').innerHTML.replaceAll('\\', ''));
        this.noResultsTemplate = _.template(parent.el.querySelector('#dealer-no-results').innerHTML.replaceAll('\\', ''));

        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', _.debounce(this.handleResize, 100));
    }

    show() {
        this.el.classList.remove('hide');
        this.animate();
    }

    hide() {
        this.el.classList.add('hide');
    }

    animate() {
        this.el.classList.remove('pre-animation');
        this.el.classList.add('apply-animation');
    }

    render(query, results) {
        if (query) {
            const toggleDealerDetailsAriaLabelTemplate = this.el.dataset.toggleDealerDetailsAriaLabel;
            const makeABookingAriaLabelTemplate = this.el.dataset.makeABookingAriaLabel;

            const dealers = results ? results.map((result) => DealerMapper.map(result)) : [];
            this.router.data.dealers = dealers;

            if(dealers.length > 0){
                dealers.forEach(dealer => {
                    dealer.toggleDealerDetailsAriaLabel = toggleDealerDetailsAriaLabelTemplate.replace(/\{0\}/g, dealer.name);
                    dealer.makeABookingAriaLabel = makeABookingAriaLabelTemplate.replace(/\{0\}/g, dealer.name);
                });
                this.el.innerHTML = this.resultsTemplate({ query, dealers });
            } else {
                this.el.innerHTML = this.noResultsTemplate({ query });
                const noResults = this.el.querySelector('.batd-search-results');
                AnalyticsHelper.template(noResults, { model: this.router.params.get(this.router.data.param), query: query });
                AnalyticsHelper.push(noResults);
            }

            this.el.querySelectorAll('li').forEach((item) => {
                const address = item.querySelector('.dealer-address');
                const cta = item.querySelector('.cta-button');

                address.addEventListener('click', (e) => this.map(e));
                cta.addEventListener('click', (e) => this.select(e));

                const mapDropLink = item.querySelector('.drop-link');
                if (this.getViewportWidth() < 800) {
                    mapDropLink.setAttribute('aria-expanded', 'false');
                }

                AnalyticsHelper.template(address, { dealer: cta.dataset.id, model: this.router.params.get(this.router.data.param), query: query });
                AnalyticsHelper.template(cta, { dealer: cta.dataset.id, model: this.router.params.get(this.router.data.param), query: query });
            });
        }

        this.loader.hide();
        this.show();
    }

    map(e) {
        e.preventDefault();
        const mapElement = e.currentTarget.closest('li').querySelector('.map');
        const mapDropLink = e.currentTarget.closest('li').querySelector('.drop-link');
        const isActive = mapElement.classList.contains('active');

        if (this.getViewportWidth() < 800) {
            e.currentTarget.closest('.flex-wrapper').querySelector('.drop-link').classList.toggle('active');
            mapElement.classList.toggle('active');
            mapDropLink.setAttribute('aria-expanded', !isActive);
        }
    }

    getViewportWidth(){
        return document.documentElement.clientWidth;
    }

    select(e) {
        e.preventDefault();
        const { id } = e.currentTarget.dataset;
        const { dealername } = e.currentTarget.dataset;
        this.router.params.set('dealer', id);
        this.router.params.set('dealername', dealername);
        this.router.update('form');
    }

    handleResize() {
        this.el.querySelectorAll('li').forEach((item) => {
            const mapDropLink = item.querySelector('.drop-link');
            if (this.getViewportWidth() < 800) {
                mapDropLink.setAttribute('aria-expanded', mapDropLink.classList.contains('active'));
            } else {
                mapDropLink.setAttribute('aria-expanded', 'true');
            }
        });
    }
}
